<div *yatVar="route$ | async as route" class="travel-ticket w-full text-sm">
  <div *ngIf="route?.from as from" class="flex gap-1">
    <yat-icon id="5f565e20-4c84-4bc3-a57f-60cf6c362268" name="location-start-duo"></yat-icon><span>{{ from }}</span>
  </div>
  <span *ngIf="route?.to as to" class="travel-ticket-to flex gap-1">
    <yat-icon id="93a84f20-b884-4739-ac87-bf9704b063df" name="location-pin-duo"></yat-icon>
    <span>
      {{ to }}
      <span *ngIf="route?.via as via">{{ 'commercialCommon.commercialHeaderTravelTicketDescription.via' | transloco: { via: via } }}</span>
    </span>
  </span>
</div>
